import React from "react";

import { ViewContainer } from "../mydashboard";
import { Body1 } from "components/texts";

function TemperatureContainer() {
  return (
    <ViewContainer>
      <Body1 lineHeight={32} fontWeight="700" color="#0D1829">
        TemperatureContainer
      </Body1>
    </ViewContainer>
  );
}

export default TemperatureContainer;
